import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrok = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.4975 12.838L15.8107 7.71927C16.1691 7.46758 16.6815 7.56564 16.8529 7.95539C17.7513 10.0117 17.3498 12.4821 15.5604 14.1782C13.772 15.8743 11.2823 16.2458 9.00715 15.3986L6.5221 16.4897C10.087 18.7995 14.4155 18.2284 17.1206 15.6625C19.2665 13.6279 19.9311 10.8546 19.3096 8.35381L19.3151 8.35987C18.414 4.68645 19.5369 3.21776 21.8359 0.215282C21.8909 0.144077 21.9459 0.0729136 22 0L18.9741 2.86881V2.86011L8.49475 12.8397M6.98775 14.0819C4.4284 11.7643 4.87025 8.17848 7.05285 6.10997C8.6671 4.57968 11.3126 3.95471 13.6217 4.87304L16.1012 3.78805C15.5859 3.42903 15.022 3.13708 14.4247 2.92C12.923 2.338 11.2731 2.18949 9.68246 2.49314C8.09186 2.79679 6.6316 3.53905 5.48535 4.62655C3.1634 6.82783 2.43285 10.2131 3.68685 13.1019C4.62365 15.2606 3.08825 16.7875 1.54185 18.3291C0.99275 18.8759 0.44275 19.4219 0 20L6.985 14.0845",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgGrok);
export default ForwardRef;
